import React from "react";

const Button = ({ variant = "primary", children, onClick, className = "" }) => {
  const baseClasses = {
    primary:
      "bg-[#0033FF] border border-[#0033FF] text-white hover:bg-[#0026cc] shadow-sm uppercase transition-all duration-300 rounded-full py-[10px] px-[24px] cursor-pointer text-[13px] font-bold tracking-wider",
    secondary:
      "bg-[#e5ebff] border border-[#e5ebff] text-[#0033FF] hover:bg-[#d0dbff] uppercase transition-all duration-300 rounded-full py-[10px] px-[24px] cursor-pointer text-[13px] font-bold tracking-wider",
    danger:
      "bg-red-500/10 border border-red-500/30 text-red-500 hover:bg-red-500/20 uppercase transition-all duration-300 rounded-full py-[10px] px-[24px] cursor-pointer text-[13px] font-bold tracking-wider",
  };

  const finalClassName = `${baseClasses[variant]} ${className}`.trim();

  return (
    <button className={finalClassName} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
